var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:(_vm.style),attrs:{"id":"container"}},[(_vm.waiting)?_c('i',{staticClass:"fa fa-spinner spin fa-2x text-white",style:({ 'margin-top': _vm.mspin })}):_vm._e(),(!_vm.waiting)?_c('iframe',{style:(_vm.style),attrs:{"src":_vm.src}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }